var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddClient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.68 65.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 74"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.69 58.18V37.59m-10.3 10.3h20.6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.69,
    cy: 47.89,
    r: 16.49
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 16.86a7.7 7.7 0 0 0 2.08.67 7.3 7.3 0 0 0 1.4.12h0A8.16 8.16 0 0 0 28 12a7.8 7.8 0 0 0 .34-2.4 8.06 8.06 0 0 0-16.12 0 9 9 0 0 0 .33 2.4 8.1 8.1 0 0 0 4.25 4.86m21.01 12.73a10.51 10.51 0 0 0-9.18-5.65H11.76A10.26 10.26 0 0 0 1.8 32c-.19.78-.3 23.16-.3 23.16l22.33.07",
    "data-name": "Layer 28"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddClient);
export default __webpack_public_path__ + "static/media/addClient.19a535b2c877b0ef42597629298d46a7.svg";
export { ForwardRef as ReactComponent };